// extracted by mini-css-extract-plugin
module.exports = {"container":"title-bar_container__dDKeo","button":"title-bar_button__ym_pW","title":"title-bar_title__tM1md","subtitle":"title-bar_subtitle__Cpl_S"};